// extracted by mini-css-extract-plugin
module.exports = {"page":"page__1cAIr","body":"body__3vK54"};